module.exports = __webpack_public_path__ + "static/media/logo_fontana.5d92c62f.png";